<template>
    <label
        v-if="!hidden"
        :title="title"
        :aria-label="title"
        :class="[
            'rounded-2xl flex items-center justify-center transition shadow-sm flex-shrink-0 cursor-pointer bg-gray-100 text-gray-600 hover:bg-gray-200',
            size === 'sm' ? 'h-[40px] w-[40px] p-2.5' : 'h-[46px] w-[46px] p-3',
            disabled ? 'opacity-50 pointer-events-none' : '',
        ]"
    >
        <input
            type="file"
            accept=".md,.markdown,.txt,text/markdown,text/plain"
            class="hidden"
            :disabled="disabled"
            @change="handleFile"
        />
        <ion-icon
            name="document-attach-outline"
            :class="size === 'sm' ? 'text-lg' : 'text-xl'"
        ></ion-icon>
    </label>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
    disabled: { type: Boolean, default: false },
    size: { type: String, default: "md" }, // 'md' | 'sm'
    // Max characters to read; guards against dumping a huge file into the prompt.
    maxChars: { type: Number, default: 20000 },
    hidden: { type: Boolean, default: false },
});

const emit = defineEmits(["upload"]);

const title = computed(() => "Attach a markdown/text file");

function handleFile(e) {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
        let text = String(reader.result || "");
        if (text.length > props.maxChars) {
            text = text.slice(0, props.maxChars);
        }
        emit("upload", text, file.name);
    };
    reader.readAsText(file);
    e.target.value = ""; // allow re-uploading the same file
}
</script>
